import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import './assets/ui-tokens.css'
import App from './App.vue'
import router from './router'
import { installAuthFetch } from './services/authFetch'
import { installChunkReloadRecovery } from './router/chunkRecovery'
import { installVersionReload } from './router/versionReload'
import { pinMachineEnvironment } from './services/machineEnvironment'

// Which machine this browser talks to — before any request, for every role.
pinMachineEnvironment()

// Attach the dashboard session token to all API-bound fetch() calls —
// course-scoped routes are auth-gated server-side. Must install before
// any component fires its first request.
installAuthFetch()

// Apply the saved light/dark theme before mount (dark is the default = no attribute).
try {
  if (localStorage.getItem('popty-theme') === 'light') document.documentElement.dataset.theme = 'light'
} catch { /* private mode — stay on default dark */ }

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

// A deploy renames every route chunk. Without this, an already-open tab's nav
// links all die silently the moment a new build lands. See chunkRecovery.js.
installChunkReloadRecovery(router)

app.mount('#app')

// Stale-version detection: a newer build deployed reloads the tab — on coming back into view, every
// few minutes, and on every page move; held while the booth would lose a take (versionReload.js).
const BUILD_VERSION = typeof __GIT_COMMIT__ !== 'undefined' ? __GIT_COMMIT__ : null

if (BUILD_VERSION && typeof document !== 'undefined') {
  installVersionReload({
    current: BUILD_VERSION,
    router,
    fetchLatest: async () => {
      const resp = await fetch('/version.json?_t=' + Date.now(), { cache: 'no-store' })
      if (!resp.ok) return null
      const { version } = await resp.json()
      return version || null
    },
    reload: () => {
      console.log(`[Popty] New version detected (current: ${BUILD_VERSION}). Reloading...`)
      window.location.reload()
    },
  })
}
